<template>
  <div
    class="resultStatus resultFinished full-width full-height flex column justify-center text-center q-px-lg"
    :class="{
      scheduledPickup:
        detail && detail.scheduled && detail.serviceType === 'PICK_UP',
    }"
  >
    <template v-if="shipmentStatusCode">
      <div v-if="isSuccessDELIVERY">
        <div
          class="title font-size-20 text-weight-bolder statuscode-box"
          :class="
            [900, 1080].includes(shipmentStatusCode)
              ? 'Driver'
              : 'statuscode-box'
          "
        >
          <div>
            <strong v-html="orderMsgs.status" />
          </div>
          <div>
            <strong> {{ orderMsgs.Driver }}</strong>
          </div>
          <div>
            <strong> {{ orderMsgs.Seller }}</strong>
          </div>
        </div>
        <div class="YourMeal-box">
          <div
            v-if="isFinishedDELIVERY"
            class="desc font-size-16 text-theme-gray q-my-sm statuscode-value"
            :class="
              [900, 1080].includes(shipmentStatusCode)
                ? 'Driver'
                : 'statuscode-value'
            "
          >
            <span> {{ orderMsgs.value }}</span>
          </div>
          <div
            v-if="[900, 1080].includes(shipmentStatusCode)"
            class="desc font-size-16 text-theme-gray q-my-sm CourierInfo"
          >
            <span> {{ orderMsgs.CourierInfo }}</span>
          </div>
          <div
            v-if="isRiderToBuyer"
            class="desc font-size-16 text-theme-gray q-my-sm CourierInfo"
          >
            <span> {{ orderMsgs.CourierInfo }}</span>
          </div>
          <div
            v-if="isRiderToBuyer"
            class="desc text-theme-gray q-my-sm GKNumber"
          >
            <span> {{ shipmentExternalId }}</span>
          </div>
        </div>

        <!-- <div class="CheckDetails">
          <span @click="alterCheck">{{ $t('result.showDetilStatus1') }}</span>
          <q-img
            src="~assets/icons/svg/icon/ChevronRight.svg"
            style="width: 16px;height: 20px;"
          />
        </div> -->
      </div>
      <div v-if="serviceTypeStatus !== 'DELIVERY'">
        <div class="title font-size-20 text-weight-bolder">
          {{ $t('result.finishedTitle') }}
        </div>
        <div class="desc font-size-16 q-my-sm text-theme-gray">
          {{
            isApartDine
              ? STORE_TABLE
              : isPick
              ? $t('result.finishedDesc1Pick')
              : $t('result.finishedDesc1Dine', [STORE_TABLE])
          }}
        </div>
        <div class="font-size-16 text-weight-bolder q-mt-md text-theme-gray">
          {{
            isApartDine
              ? STORE_TABLE
              : isPick
              ? $t('result.collarNumber')
              : `${$t('checkout.Number', [STORE_TABLE])}`
          }}
        </div>
        <!--   更改字段 新页面 没有这个 -->
        <div
          class="number text-weight-bolder font-size-60 q-mt-md"
          :class="{ 'apart-area-address': isApartDine }"
        >
          {{ mealCode }}
        </div>
      </div>
    </template>
    <SchedPick
      v-if="detail && detail.scheduled && detail.serviceType === 'PICK_UP'"
      :start-time="scheduledStartDate"
      :end-time="scheduledEndDate"
    >
      <DragVerify
        slot="DragVerify"
        class="q-mt-md"
        :start-text="$t('result.alreadyPickedUp')"
        @success="handleCompleted"
      />
    </SchedPick>
    <Popup :service-type="serviceTypeStatus" @setPopupChild="setPopupChild" />
  </div>
</template>

<script>
import DragVerify from 'src/components/DragVerify/Index.vue';
// import { sellerTracking } from 'src/api/order.js';
import orderMixins from 'pages/mixin/orderMixins.js';
import { customerOrderCompleted } from 'src/api/order';
import SchedPick from './components/SchedPick.vue';
import Popup from './Popup.vue';
import { formatDate } from '../../utils/base';

export default {
  components: {
    Popup,
    SchedPick,
    DragVerify,
  },
  mixins: [orderMixins],
  props: {
    mealCode: {
      type: String,
      default: '',
    },
    detail: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      showTypeInit: false,
      code: this.mealCode,
      serviceTypeStatus: '',
      shipmentStatusCode: '',
      paymentMethodType: '',
      shipmentExternalId: '',
      slideRatio: {
        left: 0,
        right: 0,
      },
      scheduledStartDate: '',
      scheduledEndDate: '',
    };
  },
  computed: {
    STORE_TABLE() {
      return this.$t(`list.table${this.storeInfo.businessType}`);
    },
    isDine() {
      return this.detail.serviceType === 'DINE_IN';
    },
    isPick() {
      return this.detail.serviceType === 'PICK_UP';
    },
    leftColor() {
      return this.slideRatio.left >= 1
        ? 'red-10'
        : `red-${3 + Math.round(Math.min(3, this.slideRatio.left * 3))}`;
    },

    rightColor() {
      return 'orange-2';
      // ? 'orange-2'
      // : `green-${3 + Math.round(Math.min(3, this.slideRatio.right * 3))}`;
    },
    isApartDine() {
      return this.isApartment && this.isDine;
    },
  },
  watch: {
    detail: {
      handler(val) {
        val = val || {};
        this.serviceTypeStatus = val.serviceType;
        if (val.scheduledEndDate) {
          this.scheduledStartDate = formatDate(
            val.scheduledDate?.dbStamp,
            'EEE, dd MMMM, HH:mm',
          );
          this.scheduledEndDate = formatDate(
            val.scheduledEndDate?.dbStamp,
            'HH:mm',
          );
        }
        if (val.shipment) {
          this.shipmentStatusCode = val.shipment.trackingStatusCode;
          this.paymentMethodType = val.payments[0].paymentMethodType;
          this.shipmentExternalId = val.shipment.externalId;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    if (window.history && window.history.pushState) {
      // 历史记录 插入当前界面
      window.history.pushState(null, null, document.URL);
      window.addEventListener('popstate', this.goBack, false);
    }
  },
  destroyed() {
    window.removeEventListener('popstate', this.goBack, false);
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  methods: {
    setPopupChild(child) {
      this.popupChild = child;
    },
    alterCheck() {
      if (this.popupChild) {
        this.popupChild.alert = true;
      }
    },
    getStatus(code) {
      code = +code;
      //  * 等待支付
      // WAITING_TO_PAID(200),
      if (code >= 200 && code < 300) {
        return 200;
      }
      //  * 付款成功
      // PAID(300),
      if (code >= 300 && code < 400) {
        return 300;
      }
      //  * 商家已接单
      // ACCEPTED(400),
      if (code >= 400 && code < 500) {
        return 400;
      }
      //  * 商家备餐中
      // PREPARING(500),
      if (code >= 500 && code < 600) {
        return 500;
      }
      //* 等待骑手到店取货
      // READY(600)
      if (code >= 600 && code < 610) {
        return 600;
      }
      // Searching for Courier 寻找棋手
      if (code >= 610 && code < 620) {
        return 610;
      }
      //   Driver Assigned  找到棋手
      if (code >= 620 && code < 630) {
        return 620;
      }
      /// / On the Way Pick Up  棋手正在来的路上
      if (code >= 630 && code < 700) {
        return 630;
      }
      //  * 骑手到店已取货
      // PICKED_UP(700),
      if (code >= 700 && code < 800) {
        return 700;
      }
      //  * 配送中
      // DELIVERING(800)  //Delivering to customer  棋手正在 送货
      if (code >= 800 && code < 900) {
        return 800;
      }
      //  * 已送达
      // DELIVERED(900),       // Delivered   交付完成
      if (code >= 900 && code < 1000) {
        return 900;
      }
      if (code >= 1000 && code <= 1030) {
        return 610;
      }
      /// // 订单失败状态
      if (code > 1030 && code < 1040) {
        return 1040;
      }
      return '';
    },
    goBack() {
      window.history.pushState(null, null, document.URL);
    },
    handleCompleted() {
      this.$q.loading.show({ delay: 100 });
      const params = {
        orderId: this.detail.orderId,
      };
      customerOrderCompleted(params).then((res) => {
        this.$q.loading.hide();
        if (res.code === 200) return true;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.resultFinished {
  background: url('~src/assets/images/result/completedBg.png') no-repeat center;
  background-size: cover;
  background-color: #ffffff;
  .title {
    line-height: 120%;
    margin-top: 188px;
  }
  .desc {
    line-height: 16px;
    // color: #a7f3d0;
  }
  .number {
    line-height: 100%;
  }
}
.scheduledPickup {
  padding-bottom: 46px !important;
}
// //delivery
.YourMeal {
  color: #6b7280;
  font-weight: normal;
}
.Thank-courier > div {
  color: #6b7280;
  font-weight: normal;
}
.CheckDetails {
  margin-top: 10px;
  font-weight: bold;
  color: $primary;
  font-size: 12px;
  .iconfont {
    vertical-align: middle;
  }
}

.statuscode-box {
  color: #ff9e2d;
}
.statuscode-value {
  color: #6b7280;
}

.CourierInfo {
  color: $black;
}
.GKNumber {
  font-size: 36px;
  color: $black;
  font-weight: bold;
}

.Driver {
  // color: #fff;
}
.apart-area-address {
  // color: #fff !important;
}
</style>
